export const BRAND = "Forest Hill Realtors";
export const AGENT_REG = "WBRERA/A/PAS/2026/001014";
export const PROJECT_PHASE_1 = "WBRERA/P/SOU/2026/004147";
export const PROJECT_PHASE_2 = "WBRERA/P/SOU/2026/004275";

export const WA_MESSAGE =
  "Hello Forest Hill Realtors, I am interested in Vinayak 21 Acres. Please share the latest price, availability and floor plans.";

export const MAPS = {
  embed:
    "https://www.google.com/maps?q=Hatisala%20More%2C%20Bhojerhat%20Road%2C%20New%20Town%2C%20Kolkata%20700135&z=14&output=embed",
  directions:
    "https://www.google.com/maps/search/?api=1&query=Hatisala%20More%2C%20Bhojerhat%20Road%2C%20New%20Town%2C%20Kolkata%20700135",
};

export const NAV_LINKS = [
  { label: "Overview", href: "#overview" },
  { label: "Highlights", href: "#highlights" },
  { label: "Amenities", href: "#amenities" },
  { label: "Floor Plans", href: "#floor-plans" },
  { label: "Location", href: "#location" },
  { label: "Specifications", href: "#specifications" },
  { label: "Contact", href: "#contact" },
];

export const QUICK_HIGHLIGHTS = [
  { icon: "Building2", title: "2 & 3 BHK Residences", desc: "Thoughtfully planned homes with efficient, liveable layouts." },
  { icon: "MapPin", title: "Hatishala, Off Action Area III", desc: "Adjacent to Newtown Action Area III, Kolkata's growth corridor." },
  { icon: "Compass", title: "90% 3-Side Open Homes", desc: "Open views, daylight and breeze from three directions." },
  { icon: "Layers", title: "Double-Height Sky Terraces", desc: "Elevated outdoor decks with a dramatic sense of volume." },
  { icon: "Sun", title: "Vastu-Compliant Layouts", desc: "Orientations planned in line with Vastu principles." },
  { icon: "Leaf", title: "IGBC Platinum Precertified", desc: "Precertified Platinum rated green building by IGBC." },
  { icon: "Trees", title: "3-Acre Central Park", desc: "A sweeping green heart at the centre of the community." },
  { icon: "Bus", title: "Metro Shuttle Service", desc: "Planned shuttle service to the nearest metro station." },
];

export const APARTMENT_FEATURES = [
  { title: "90% Homes with 3-Side Open Views", desc: "Supporting abundant natural light and continuous cross ventilation through the day." },
  { title: "Double-Height Sky Terraces", desc: "Creating a greater sense of openness and vertical volume — your own deck in the sky." },
  { title: "Efficient Floor Plans", desc: "Designed to reduce unnecessary circulation space, so more of every home is truly usable." },
  { title: "Vastu-Compliant Layouts", desc: "Entrances and room orientations aligned with Vastu principles for harmonious living." },
  { title: "Natural Light & Ventilation", desc: "Windows and openings placed to keep interiors bright, airy and energy-conscious." },
  { title: "Layouts Designed for Ease of Living", desc: "Practical room proportions and storage-friendly planning for everyday comfort." },
];

export const SUSTAINABILITY = [
  "IGBC Precertified Platinum Rated Green Building",
  "Water-efficient fixtures",
  "Solar power for common lighting",
  "Waste recycling and management",
  "Grey water treatment plant",
  "LED common-area lighting",
  "Rainwater harvesting",
  "Provision for EV charging",
  "Low-VOC paints",
  "High solar reflective index roof tiles",
];

export const OUTDOOR_LIFESTYLE = [
  "3-Acre Central Park", "Theme Garden", "Open-Air Futsal Ground", "Athletic Track",
  "Lawn Tennis Court", "Cricket Play Arena", "Pet Park", "Forest Trail",
  "Jogging Track", "Cycling Track", "Podium Garden",
];

export const CENTRAL_PARK_FEATURES = [
  "Elevated Cabanas", "Grand Lawn", "Kids' Play Areas", "Open-Air Amphitheatre",
  "Cascading Waters", "Adventure Play Area", "Open-Air Skating Rink", "Pickleball Court",
  "Badminton Court", "Mini Basketball Court", "Barbecue Nook", "Maze Garden",
  "Senior Citizens' Seating", "Outdoor Fitness Zone",
];

export { FLOOR_PLANS } from "./floorplans";

export const FLOOR_PLAN_FILTERS = ["2 BHK", "3 BHK Smart", "3 BHK Comfort", "3 BHK Luxury"];

export const LOCATION_GROUPS = [
  {
    category: "Major Landmarks",
    items: [
      { name: "Biswa Bangla Gate", time: "12 mins" },
      { name: "Nearest Metro", time: "12 mins" },
      { name: "Airport", time: "30 mins" },
      { name: "Science City", time: "30 mins" },
    ],
  },
  {
    category: "Work",
    items: [
      { name: "Infosys", time: "1 min" },
      { name: "ITC Infotech", time: "2 mins" },
      { name: "Wipro", time: "2 mins" },
      { name: "Unitech Infospace", time: "10 mins" },
      { name: "TCS", time: "12 mins" },
    ],
  },
  {
    category: "Shopping",
    items: [
      { name: "Gabtala Bazaar", time: "1 min" },
      { name: "Spencer's", time: "6 mins" },
      { name: "Downtown Mall", time: "7 mins" },
      { name: "Rosedale Plaza", time: "7 mins" },
    ],
  },
  {
    category: "Healthcare",
    items: [
      { name: "Wellcare Nursing Home", time: "under 1 min" },
      { name: "Tata Medical Centre", time: "12 mins" },
      { name: "Neotia Bhagirathi", time: "15 mins" },
      { name: "Ohio Hospital", time: "15 mins" },
    ],
  },
  {
    category: "Education",
    items: [
      { name: "Army Institute of Management", time: "5 mins" },
      { name: "Orchids The International School", time: "7 mins" },
      { name: "UEM", time: "7 mins" },
      { name: "St Xavier's University", time: "7 mins" },
      { name: "DPS Newtown", time: "15 mins" },
      { name: "The Newtown School", time: "15 mins" },
      { name: "Sister Nivedita University", time: "15 mins" },
      { name: "Techno International", time: "15 mins" },
      { name: "Narayana School", time: "20 mins" },
    ],
  },
];

export const SPECIFICATIONS = [
  { section: "Structure", items: ["RCC framed structure", "Seismic consideration as per applicable IS code"] },
  { section: "Walls", items: ["Exterior concrete walls using Mivan technology", "Interior AAC blocks"] },
  { section: "Living / Dining", items: ["Premium finish vitrified tiles"] },
  { section: "Bedrooms", items: ["Premium vitrified tiles"] },
  { section: "Kitchen", items: ["Granite counter", "Stainless steel sink", "Vitrified flooring", "Electrical points for appliances"] },
  { section: "Toilets", items: ["Anti-skid tiles", "Reputed sanitaryware and CP fittings"] },
  { section: "Balcony & Sky Terrace", items: ["Premium vitrified tiles", "MS railing"] },
  { section: "Doors & Windows", items: ["Flush doors", "Aluminium casement windows"] },
  { section: "Electrical", items: ["Modular switches", "Concealed copper wiring", "AC points in bedrooms and living/dining"] },
  { section: "Security", items: ["Video door phone", "CCTV in common areas"] },
  { section: "Elevators", items: ["3 high-speed elevators in each tower"] },
];

export const FAQS = [
  { q: "Where is Vinayak 21 Acres located?", a: "Vinayak 21 Acres is located at Hatishala, adjacent to Newtown Action Area III, Kolkata — close to the IT hub, schools, hospitals and daily conveniences of New Town." },
  { q: "What configurations are available?", a: "The project offers 2 BHK and 3 BHK residences across Smart, Comfort and Luxury categories, varying by tower and unit type." },
  { q: "Is Vinayak 21 Acres RERA registered?", a: "According to available project information, the project's phases carry WBRERA registrations — Phase 1: WBRERA/P/SOU/2026/004147 and Phase 2: WBRERA/P/SOU/2026/004275. Forest Hill Realtors is a WBRERA-registered real estate agent (WBRERA/A/PAS/2026/001014). Please verify all registrations on the official WBRERA website before booking." },
  { q: "Where can I check the floor plans?", a: "All 40 official floor plans — 2 BHK and 3 BHK Smart, Comfort and Luxury across Towers 1A, 1B, 2A, 2B and 2C — can be viewed in the Floor Plans section on this page and on our dedicated floor plans page, each with verified carpet area, balcony, BUA and SBUA." },
  { q: "What apartment sizes are available?", a: "The 2 BHK 2T offers approx. 595–597 sq ft carpet (971 sq ft SBUA). 3 BHK Smart is about 703 sq ft carpet (1138–1162 sq ft SBUA), 3 BHK Comfort about 774 sq ft carpet (1250–1268 sq ft SBUA), and 3 BHK Luxury about 873 sq ft carpet (1476–1491 sq ft SBUA). Exact figures vary by tower, type and floor — view the official floor plans in the Floor Plans section or contact Forest Hill Realtors for the detailed sheet." },
  { q: "Does the project offer sky terraces?", a: "Yes. Residences feature double-height sky terraces that create a greater sense of openness and vertical volume." },
  { q: "What amenities are planned?", a: "Highlights include a 3-acre central park, theme garden, futsal ground, athletic track, lawn tennis, cricket play arena, pet park, forest trail, jogging and cycling tracks, elevated cabanas, an open-air amphitheatre and more." },
  { q: "How far is the nearest metro?", a: "The nearest metro is indicatively about 12 minutes away. Travel times are indicative and may vary with traffic and route." },
  { q: "Is shuttle service available?", a: "A shuttle service to the nearest metro is planned as part of the project's convenience offerings." },
  { q: "How can I get current price and availability?", a: "Pricing and availability are subject to change. Please contact Forest Hill Realtors for the latest information." },
  { q: "How can I book a site visit?", a: "Use the Book a Site Visit button, the sticky mobile bar, or WhatsApp us — Forest Hill Realtors will arrange a convenient visit slot for you." },
  { q: "Who is Forest Hill Realtors?", a: "Forest Hill Realtors is the authorised channel partner for Vinayak 21 Acres and a WBRERA-registered real estate agent (Reg. No. WBRERA/A/PAS/2026/001014). We are not the developer of the project." },
];

export const IMAGES = {
  hero: "/assets/hero-aerial.jpg",
  tower: "https://images.unsplash.com/photo-1763929065066-6743f638ecd8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  living: "/assets/bedroom.jpg",
  park: "/assets/central-park.jpg",
  terrace: "https://images.unsplash.com/photo-1777203005300-b99f45292bfe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  garden: "/assets/masterplan.jpg",
  certificate: "/assets/igbc-cert.jpg",
};
